module.exports = require('./helpers/bundle-url').getBundleURL('dUqIU') + "logo.c51670a8.svg";